// IE SUPPORT
import './prependPolyfill.js'

import {
  gsap
} from 'gsap'

import ScrollMagic from 'scrollmagic'
import 'scrollmagic/scrollmagic/minified/plugins/animation.gsap.min.js'
import 'scrollmagic/scrollmagic/minified/plugins/debug.addIndicators.min.js'

var controller = new ScrollMagic.Controller();

export default {
  inserted: (el, binding) => {

    // GENERATE AND PREPEND TRIGGER ELEMENT
    let className = "";
    const characters = "abcdefghijklmnopqrstuvwxyz";
    for (var i = 0; i < 5; i++) {
      className += characters.charAt(Math.floor(Math.random() * characters.length));
    }

    const triggerElement = document.createElement('div');
    triggerElement.setAttribute("class", 'trigger-' + className);
    el.prepend(triggerElement);

    const defaultSceneOptions = {
      duration: 0,
      offset: 0,
      triggerElement: triggerElement,
      triggerHook: 0.8,
      reverse: false,
      loglevel: 2
    }

    // SET SCENE OPTIONS
    let sceneOptions = defaultSceneOptions;

    if (binding.value && binding.value.sceneOptions) {
      sceneOptions = Object.assign(defaultSceneOptions, binding.value.sceneOptions);
    }

    const scene = new ScrollMagic.Scene(sceneOptions);

    // ANIMATE
    if (binding.value && binding.value.setTween) {
      let TweenMaxAnimations;

      TweenMaxAnimations = binding.value.setTween

      if (!binding.value.setTween.stagger) {
        scene.setTween(gsap.to(el, TweenMaxAnimations))
      } else {

        var childs = [];

        for (var i = 0; i < el.childNodes.length; i++) {

          if (el.childNodes[i].className) {
            if (el.childNodes[i].className.includes(binding.value.staggerEl)) {
              childs.push(el.childNodes[i]);
            }
          }
        }

        scene.setTween(gsap.to(childs, TweenMaxAnimations))
      }

    } else {
      scene.setClassToggle(el, "animate")
    }

    scene.addTo(controller)

    if (binding.arg && binding.arg === 'debug') {
      scene.addIndicators();
    }
  }
}